import { recordPage } from "config/consts";

export const calculateMaxPage = (totalItems: number, itemsOnEachPage: number = recordPage) => {
    let maxPage = totalItems;
    if (maxPage / itemsOnEachPage === 1 || maxPage / itemsOnEachPage < 1) {
        maxPage = 0;
    } else if (maxPage % itemsOnEachPage === 0 && maxPage / itemsOnEachPage) {
        maxPage = maxPage / itemsOnEachPage;
    } else {
        maxPage = Math.trunc(maxPage / itemsOnEachPage) + 1;
    }
    return maxPage
};

export default calculateMaxPage;